import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  IoBusinessOutline, 
  IoSearch, 
  IoCloseCircle, 
  IoChevronForward, 
  IoNavigateOutline 
} from 'react-icons/io5';

// Web Storage wrapper (using localStorage)
const storage = {
  getItem: (key) => {
    try {
      return localStorage.getItem(key);
    } catch (error) {
      //console.error('Error getting item from localStorage:', error);
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      //console.error('Error setting item in localStorage:', error);
    }
  }
};

// Styles
const styles = {
  mainContainer: {
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    display: 'flex',
    flexDirection: 'column',
  },
  scrollContainer: {
    flex: 1,
    padding: '16px',
    maxWidth: '800px',
    margin: '0 auto',
    width: '100%',
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px',
    minHeight: '400px',
  },
  loadingSpinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #f3f3f3',
    borderTop: '4px solid #137a7f',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  loadingText: {
    marginTop: '16px',
    fontSize: '16px',
    color: '#666',
    textAlign: 'center',
  },
  searchContainer: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#fff',
    borderRadius: '12px',
    paddingHorizontal: '16px',
    marginBottom: '20px',
    borderWidth: '1px',
    borderColor: '#ddd',
    borderStyle: 'solid',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  searchIcon: {
    marginRight: '12px',
    fontSize: '20px',
    color: '#999',
  },
  input: {
    flex: 1,
    height: '50px',
    fontSize: '16px',
    color: '#333',
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
  },
  clearButton: {
    padding: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'none',
    border: 'none',
  },
  clearIcon: {
    fontSize: '20px',
    color: '#999',
  },
  resultsCount: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '16px',
    textAlign: 'center',
  },
  unitCard: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    marginBottom: '16px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    borderWidth: '1px',
    borderColor: '#e0e0e0',
    borderStyle: 'solid',
    overflow: 'hidden',
  },
  unitContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '20px',
    borderBottomWidth: '1px',
    borderBottomColor: '#f0f0f0',
    borderBottomStyle: 'solid',
    cursor: 'pointer',
  },
  unitInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  unitIcon: {
    fontSize: '24px',
    color: '#137a7f',
  },
  unitText: {
    marginLeft: '16px',
    flex: 1,
  },
  unitName: {
    fontSize: '16px',
    fontWeight: '500',
    color: '#333',
    marginBottom: '4px',
  },
  locationAvailable: {
    fontSize: '12px',
    color: '#4caf50',
    fontWeight: '500',
  },
  locationUnavailable: {
    fontSize: '12px',
    color: '#999',
    fontStyle: 'italic',
  },
  chevronIcon: {
    fontSize: '20px',
    color: '#999',
  },
  directionsButton: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px',
    backgroundColor: '#f8f9fa',
    cursor: 'pointer',
    border: 'none',
    width: '100%',
  },
  directionsButtonDisabled: {
    backgroundColor: '#f5f5f5',
    cursor: 'not-allowed',
    opacity: 0.6,
  },
  directionsText: {
    fontSize: '14px',
    color: '#137a7f',
    fontWeight: '500',
    marginLeft: '8px',
  },
  directionsTextDisabled: {
    color: '#999',
  },
  emptyContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px',
  },
  emptyIcon: {
    fontSize: '64px',
    color: '#ccc',
  },
  emptyText: {
    fontSize: '16px',
    color: '#666',
    textAlign: 'center',
    marginTop: '16px',
  },
  emptySubText: {
    fontSize: '14px',
    color: '#666',
    textAlign: 'center',
    marginTop: '8px',
  },
  navbar: {
    backgroundColor: '#137a7f',
    padding: '16px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  navbarTitle: {
    color: 'white',
    fontSize: '18px',
    fontWeight: '600',
    margin: 0,
  },
  backButton: {
    position: 'absolute',
    left: '20px',
    background: 'none',
    border: 'none',
    color: 'white',
    fontSize: '20px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  backButtonText: {
    fontSize: '14px',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modalContent: {
    backgroundColor: 'white',
    borderRadius: '15px',
    padding: '20px',
    width: '90%',
    maxWidth: '400px',
  },
  modalTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#137a7f',
    marginBottom: '20px',
    textAlign: 'center',
  },
  modalButtons: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
    marginTop: '20px',
  },
  modalButton: {
    padding: '10px 20px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: '500',
  },
  modalButtonCancel: {
    backgroundColor: '#f0f0f0',
    color: '#666',
  },
  modalButtonConfirm: {
    backgroundColor: '#137a7f',
    color: 'white',
  },
};

// Add keyframes animation
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(styleSheet);

// NavBar Component
const NavBar = ({ title, showBackButton = false }) => {
  const navigate = useNavigate();

  return (
    <div style={styles.navbar}>
      {showBackButton && (
        <button
          onClick={() => navigate(-1)}
          style={styles.backButton}
        >
          ← <span style={styles.backButtonText}>Voltar</span>
        </button>
      )}
      <h1 style={styles.navbarTitle}>{title}</h1>
    </div>
  );
};

// Modal Component
const ConfirmModal = ({ visible, title, message, onConfirm, onCancel }) => {
  if (!visible) return null;

  return (
    <div style={styles.modalOverlay} onClick={onCancel}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3 style={styles.modalTitle}>{title}</h3>
        <p style={{ textAlign: 'center', marginBottom: '20px' }}>{message}</p>
        <div style={styles.modalButtons}>
          <button
            style={{ ...styles.modalButton, ...styles.modalButtonCancel }}
            onClick={onCancel}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default function ListaUnidadesScreen() {
  const [unidades, setUnidades] = useState([]);
  const [filtro, setFiltro] = useState('');
  const [loading, setLoading] = useState(true);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [alertTitle, setAlertTitle] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const storedLink = storage.getItem('link');
        const storedChave = storage.getItem('chave');
        const storedGuid = storage.getItem('govbr_guid');
        const guidParam = storedGuid ? `&GUID=${storedGuid}` : '';

        if (!storedLink || !storedChave) {
          setLoading(false);
          return;
        }

        const url = `${storedLink}/apidadospaciente.rule?sys=SAU&p1=${storedChave}&p2=unidades${guidParam}`;
        //console.log('URL da API (unidades):', url);
        
        const response = await fetch(url);
        const data = await response.json();
        
        //console.log('Resposta da API (unidades):', data);

        if (data.status === 'success' && data.dados && data.dados.length > 0) {
          const unidadesFiltradas = data.dados.filter((item) => 
            item.UNIDADE && item.UNIDADE.trim() !== ''
          );
          setUnidades(unidadesFiltradas);
        } else {
          //console.log('API não retornou unidades válidas');
          setUnidades([]);
        }
      } catch (error) {
        //console.log('Erro ao buscar unidades:', error);
        setUnidades([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Função para verificar se há dados
  const hasAnyData = () => {
    return Array.isArray(unidades) && unidades.length > 0;
  };

  const unidadesFiltradas = unidades.filter(item =>
    item.UNIDADE?.toLowerCase().includes(filtro.toLowerCase())
  );

  const handleUnitPress = async (cod) => {
    try {
      const storedLink = storage.getItem('link');
      const storedChave = storage.getItem('chave');
      const storedGuid = storage.getItem('govbr_guid');
      const guidParam = storedGuid ? `&GUID=${storedGuid}` : '';

      if (!storedLink || !storedChave) {
        setAlertTitle('Erro');
        setAlertMessage('Configurações não encontradas');
        setShowAlert(true);
        return;
      }

      const url = `${storedLink}/apidadospaciente.rule?sys=SAU&p1=${storedChave}&p2=especialidades&p11=${cod}${guidParam}`;
      const response = await fetch(url);
      const data = await response.json();

      if (data.status === 'error' && data.msg === 'Nenhum registro encontrado') {
        setAlertTitle('Aviso');
        setAlertMessage('Sem registros para esta unidade');
        setShowAlert(true);
      } else {
        storage.setItem('codUnidade', cod.toString());
        navigate('/especialidades');
      }
    } catch (error) {
      setAlertTitle('Erro');
      setAlertMessage('Houve um problema ao verificar a unidade');
      setShowAlert(true);
    }
  };

  const handleComoChegarPress = (unidade) => {
    if (!unidade.LATITUDE || !unidade.LONGITUDE) {
      setAlertTitle('Aviso');
      setAlertMessage('Localização indisponível para esta unidade');
      setShowAlert(true);
      return;
    }

    try {
      // Abrir Google Maps com as coordenadas
      const url = `https://www.google.com/maps/search/?api=1&query=${unidade.LATITUDE},${unidade.LONGITUDE}`;
      window.open(url, '_blank');
    } catch (error) {
      //console.error('Erro ao abrir maps:', error);
      setAlertTitle('Erro');
      setAlertMessage('Não foi possível abrir o aplicativo de mapas');
      setShowAlert(true);
    }
  };

  return (
    <div style={styles.mainContainer}>
      <NavBar title="Unidades" showBackButton={true} />

      <div style={styles.scrollContainer}>
        {loading ? (
          <div style={styles.loadingContainer}>
            <div style={styles.loadingSpinner} />
            <div style={styles.loadingText}>Carregando unidades...</div>
          </div>
        ) : !hasAnyData() ? (
          <div style={styles.emptyContainer}>
            <IoBusinessOutline style={styles.emptyIcon} />
            <div style={styles.emptyText}>Nenhuma unidade encontrada</div>
            <div style={styles.emptySubText}>
              Consulte a Unidade de Saúde para obter informações sobre unidades disponíveis.
            </div>
          </div>
        ) : (
          <>
            <div style={styles.searchContainer}>
              <IoSearch style={styles.searchIcon} />
              <input
                type="text"
                style={styles.input}
                placeholder="Pesquisar unidade..."
                value={filtro}
                onChange={(e) => setFiltro(e.target.value)}
              />
              {filtro.length > 0 && (
                <button
                  onClick={() => setFiltro('')}
                  style={styles.clearButton}
                >
                  <IoCloseCircle style={styles.clearIcon} />
                </button>
              )}
            </div>

            <div style={styles.resultsCount}>
              {unidadesFiltradas.length} unidade{unidadesFiltradas.length !== 1 ? 's' : ''} encontrada{unidadesFiltradas.length !== 1 ? 's' : ''}
            </div>

            {unidadesFiltradas.length > 0 ? (
              unidadesFiltradas.map((item, index) => (
                <div key={index} style={styles.unitCard}>
                  <div
                    onClick={() => handleUnitPress(item.COD)}
                    style={styles.unitContent}
                  >
                    <div style={styles.unitInfo}>
                      <IoBusinessOutline style={styles.unitIcon} />
                      <div style={styles.unitText}>
                        <div style={styles.unitName}>{item.UNIDADE}</div>
                        {item.LATITUDE && item.LONGITUDE ? (
                          <div style={styles.locationAvailable}>Localização disponível</div>
                        ) : (
                          <div style={styles.locationUnavailable}>Localização indisponível</div>
                        )}
                      </div>
                    </div>
                    <IoChevronForward style={styles.chevronIcon} />
                  </div>

                  <button
                    onClick={() => handleComoChegarPress(item)}
                    style={{
                      ...styles.directionsButton,
                      ...((!item.LATITUDE || !item.LONGITUDE) ? styles.directionsButtonDisabled : {})
                    }}
                    disabled={!item.LATITUDE || !item.LONGITUDE}
                  >
                    <IoNavigateOutline
                      size={20}
                      color={(!item.LATITUDE || !item.LONGITUDE) ? "#999" : "#137a7f"}
                    />
                    <span style={{
                      ...styles.directionsText,
                      ...((!item.LATITUDE || !item.LONGITUDE) ? styles.directionsTextDisabled : {})
                    }}>
                      Como chegar
                    </span>
                  </button>
                </div>
              ))
            ) : (
              <div style={styles.emptyContainer}>
                <IoBusinessOutline style={styles.emptyIcon} />
                <div style={styles.emptyText}>
                  {filtro ? 'Nenhuma unidade encontrada para a pesquisa.' : 'Nenhuma unidade encontrada.'}
                </div>
              </div>
            )}
          </>
        )}
      </div>

      <ConfirmModal
        visible={showAlert}
        title={alertTitle}
        message={alertMessage}
        onConfirm={() => setShowAlert(false)}
        onCancel={() => setShowAlert(false)}
      />
    </div>
  );
}